import {
  business_days,
  every_x_days,
  every_x_months,
  every_x_months_last_day,
  every_x_months_last_working_day,
  every_x_weeks,
  every_x_years,
  Schedule,
  specific_dates,
  weekdays,
} from "../../../../backend/types-v2";
import { Frequency } from "../GenericTable";

export const scheduleLabels: Record<Schedule["kind"], string> = {
  [every_x_days]: "Days",
  [every_x_weeks]: "Weeks",
  [every_x_months]: "Monthly",
  [every_x_months_last_working_day]: "Monthly",
  [every_x_months_last_day]: "Monthly",
  [every_x_years]: "Years",
  [weekdays]: "Weekdays",
  [specific_dates]: "Specific dates",
  [business_days]: "business",
};

export const recurringScheduleUnitLabels: Partial<Record<Frequency, string>> = {
  daily: "Days",
  weekdays: "Weekdays",
  weekly: "Weeks",
  monthly: "Months",
  yearly: "Years",
};

export const getMaxInterval = (frequency: Frequency | null) => {
  switch (frequency) {
    case "daily":
      return 30;
    case "weekly":
      return 52;
    case "monthly":
      return 12;
    case "yearly":
      return Infinity;
    case "weekdays":
      return 1;
    case null:
      return 0;
    default:
      throw new Error(`Unsupported frequency ${frequency}`);
  }
};
